
<template>
  <v-breadcrumbs :items="items">
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item
          :href="item.href"
          :disabled="item.disabled"
      >
        {{ item.text.toUpperCase() }}
      </v-breadcrumbs-item>
    </template>
    <div class="card_container" >
      <div class="card_header" >
        <div>ข้อมูลชิ้นงาน</div>
        <div class="date-picker-container" >

          <v-btn
              class="mx-2"
              fab
              dark
              color="indigo"
              to="/ProductCreate"
          >
            <v-icon dark>
              mdi-plus
            </v-icon>
          </v-btn>
        </div>

      </div>

      <v-breadcrumbs :items="items">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
              :href="item.href"
              :disabled="item.disabled"
          >
            {{ item.text.toUpperCase() }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>

      <div class="search_container" >
        <div class="search-form" >
          <v-text-field v-model="search" label="ค้นหา" class="search_ip"  ></v-text-field>
        </div>
      </div>

      <v-data-table
          :headers="headers"
          :items="resultData"
          :search="search"
          hide-actions
          sort-by="calories"
          class="elevation-1"
      >
        <template v-slot:top>
        </template>
        <template v-slot:item.image="{ item }">
          <img class="img_thumb" v-bind:src="baseUrl+'/'+item.image.path.replace('media','')"  ><br>
          <img class="img_thumb" v-bind:src="'https://system.yn-engineering.com/qrcode/'+item.code"  >
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon
              small
              class="mr-2 icon-custom"
              @click="Removetocks(item.product_id,item.codes,item.machine_id,item.name)"
          >
            mdi-plus
          </v-icon>
          <v-icon
              small
              class="mr-2 icon-custom"
              @click="AddStocks(item.product_id,item.codes,item.machine_id,item.name)"
          >
            mdi-minus
          </v-icon>
          <v-icon
              small
              class="mr-2 icon-custom"
              @click="editItem(item.codes)"
          >
            mdi-pencil
          </v-icon>
        </template>
        <template v-slot:item.disable="{ item }">
          <v-switch
              color="red"
              :input-value="parseInt(item.deactive) !== 1 ? false : true"
              :v-model="parseInt(item.deactive) !== 1 ? false : true"
              @change="Disable(item.codes,parseInt(item.deactive) !== 1 ? false : true ,item.machine_id)"
              flat
          ></v-switch>
        </template>
        <template v-slot:item.check="{ item }">
          <v-icon
              small
              class="mr-2 icon-custom"
              @click="CheckItem(item.codes,item.machine_id)"
          >
            mdi-refresh
          </v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn
              color="primary"
              @click="initialize"
          >
            Reset
          </v-btn>
        </template>

      </v-data-table>


      <v-row justify="center">
        <v-dialog
            width="500"
            v-model="dialog"
        >
          <v-card>
            <v-card-title class="text-h5 custom-stock-text">
              {{  this.type === 1 ?  "เพิ่มสต๊อก" : "ตัดสต๊อก" }}สินค้า {{ this.name }}
            </v-card-title>
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                >
                  <div style="padding:2rem" >
                    <v-text-field
                        v-model="stock"
                        :rules="[v => !!v || 'กรุณากรอกจำนวน']"
                        label="จำนวนสินค้า"
                        required
                        color="white"
                        class="custom-input-color"
                    ></v-text-field>
                  </div>

                </v-form>
                <div class="btn-list" >
                  <v-btn
                      depressed
                      color="primary"
                      @click="submit"
                  >
                    {{  this.type === 1 ?  "เพิ่มสต๊อก" : "ตัดสต๊อก" }}
                  </v-btn>
                  <v-btn
                      depressed
                      color="error"
                      @click="dialog = false"
                  >
                    ยกเลิก
                  </v-btn>
                </div>
          </v-card>
        </v-dialog>
      </v-row>


    </div>
  </v-breadcrumbs>




</template>



<script>
import {
  AddStock,
  CheckProduct,
  DeleteProduct,
  GetMachine,
  GetProductAll,
  RestoreProduct,
} from "../../lib/controller";
import {baseUrl} from "../../const/api";


export default {
  name: "Users",
  data: () => ({
    baseUrl:baseUrl,
    name:"",
    stock:0,
    product_id:"",
    codes:"",
    machine_ids:"",
    valid: true,
    search: "",
    dialog: false,
    items: [
      {
        text: 'Home',
        disabled: false,
        href: '/',
      },
      {
        text: 'ข้อมูลชิ้นงาน',
        disabled: true,
        href: '/Product',
      },
    ],

    dialogDelete: false,
    showModal: true,
    headers: [
      {
        text: 'รูปชิ้นงาน',
        align: 'start',
        sortable: false,
        value: 'image',
      },
      { text: 'ชื่อ', value: 'name' },
      { text: 'รหัส', value: 'code' },
      { text: 'ประเภทชิ้นงาน', value: 'categories[0].title' },
      { text: 'ประเภทย่อยชิ้นงาน', value: 'subcategory[0].title' },
      { text: 'จำนวนคงเหลือ', value: 'stock' },
      { text: 'ตำแหน่งชิ้นงาน', value: 'position' },
      { text: 'แก้ไข', value: 'actions', sortable: false },
      { text: 'ยกเลิก', value: 'disable' },
      { text: 'เช็คข้อมูล', value: 'check' },
    ],
    desserts: [],
    editedIndex: -1,
    resultData:[],
    machine_id: JSON.parse(localStorage.getItem('user')).machine_id,
    machine_item: {},
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },
  },
  watch: {

  },
  created () {
    this.initialize()
    this.getData()
    this.GetMachines()
  },

  methods: {
    async AddStocks(product_id,code,machine,title){
      this.dialog = true;
      this.codes = code;
      this.machine_id = machine;
      this.name = title;
      this.product_id = product_id;
      this.type = 2;
    },
    async Removetocks(product_id,code,machine,title){
      this.dialog = true;
      this.codes = code;
      this.machine_id = machine;
      this.name = title;
      this.product_id = product_id;
      this.type = 1;
    },
    async submit() {
      this.dialog = false;

      console.log(this.file)
      if(this.$refs.form.validate()){
        //this.ProductUpdate();

        let formData = new FormData();

        formData.append("product_id",this.product_id)
        formData.append("type",this.type)
        formData.append("amount",this.stock)
        formData.append("codes_product",this.codes)
        formData.append("machine_id",this.machine_id)
        const { status  } = await AddStock(formData,this.machine_id);
        if(status){
          console.log("OK")

          this.getData()
        }

      }



    },
    async GetMachines(){
      let machine = [];
      const { status , results } = await GetMachine();
      if(status === 200){

        machine.push({
          "label":"ทั้งหมด",
          "id":99,
        })

        results.data.forEach(function (result){
          console.log(result)
          machine.push({
            "label":result.title,
            "id":result.machine_number,
          })
        });
      }

      this.machine_item = machine;
      console.log(this.machine_item)

    },
   async editItem(id) {
     this.$router.push({ path: '/Product/'+id })
    },
    async CheckItem(id,machine_id) {
      let Swal = this.$swal;

      const { status  } = await CheckProduct(id,machine_id);
      if(status === 200) {
        Swal({
          icon: 'success',
          title: 'Success',
        })

       await this.getData()

      }
    },
    async deleteItem(id,machine){
      console.log(id)
      this.$swal({
        title: 'ต้องการลบใช่หรือไม่ ?',
        showCancelButton: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText:"ยกเลิก",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
            this.delete(id,machine)
        }
      })

      ;
    },
    async Disable(id,value,machine){

        if(value){

          let Swal = this.$swal;
          const { status } = await RestoreProduct(id,machine);
          if(status === 200){
            Swal({
              icon: 'success',
              title: 'Success',
            })
            await this.getData()
          }

        }else{

          let Swal = this.$swal;
          const { status } = await DeleteProduct(id,machine);
          if(status === 200){
            Swal({
              icon: 'success',
              title: 'Success',
            })
            await this.getData()
          }

        }




    },
    initialize () {

    },
   async getData(){

     let params = {};

     params.machine_id = this.machine_id

      const { status,results } = await GetProductAll(params);
      if(status === 200){
        this.resultData = results.data;
      }
    },

    async delete(id,machine){
      let Swal = this.$swal;
      const { status } = await DeleteProduct(id,machine);
      if(status === 200){
        Swal({
          icon: 'success',
          title: 'Success',
        })
       await this.getData()
      }
    },


  },
}


</script>

<style scoped>
.date-picker-container{
  display: flex;
  gap: 15px;
}
.card_container{
  width: 100%;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #ffffff;
  background-clip: border-box;
  border: 1px solid #EBEDF3;
  border-radius: 0.42rem;
}
.card_header{
  padding: 1.5rem 2rem;
  margin-bottom: 0;
  background-color: #ffffff;
  border-bottom: 1px solid #EBEDF3;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.img_thumb{
  width:8rem;
  border-radius:10px;
  margin:0.2rem;
}
.search_ip{
  font-size: 1rem;
}
.search_container{
  display: flex;
  justify-content: flex-end;
  padding: 1rem;
}
.search-form{
  width: 20%;
}
</style>
